import axiosInstance from "../Axios/axiosInstance";

const getAllAreas = async () => {
  return await axiosInstance.get("/areas/");
};

const getAreaById = async (id) => {
  return await axiosInstance.get(`/areas/entry/${id}`);
};

const addArea = async (data) => {
  return await axiosInstance.post("/areas/", {
    name: data.name,
    branchId: data.branchId,
  });
};

const editArea = async (id, data) => {
  return await axiosInstance.put(`/areas/${id}`, data);
};

const deleteArea = async (id) => {
  return await axiosInstance.delete(`/areas/${id}`);
};

export default {
  getAllAreas,
  getAreaById,
  addArea,
  editArea,
  deleteArea,
};
